import React from 'react';

interface IconProps {
	/** Rendered width and height in px. Matches the react-icons convention. */
	size?: number | string;
	[key: string]: any;
}

/**
 * home-in-brackets, from the (new) BAY Design System (node 44321:117).
 *
 * Two paths: the four corner brackets, and the house inside them. Both use
 * currentColor so the icon takes its colour from the surrounding text.
 *
 * Takes `size` the way react-icons components do, so it drops into any wrapper
 * that sizes icons by prop rather than width/height — the email editor's
 * ReactIcon passes `size`. Explicit width/height still win, since props spread
 * last.
 */
const HomeBracketsIcon = ({ size = 20, ...props }: IconProps) => {
	return (
		<svg
			fill="none"
			height={size}
			viewBox="0 0 14 14"
			width={size}
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M1.3125 0.875C1.07088 0.875 0.875 1.07088 0.875 1.3125V4.8125C0.875 5.05412 0.679125 5.25 0.4375 5.25C0.195875 5.25 0 5.05412 0 4.8125V1.3125C0 0.587626 0.587626 0 1.3125 0H4.8125C5.05412 0 5.25 0.195875 5.25 0.4375C5.25 0.679125 5.05412 0.875 4.8125 0.875H1.3125ZM8.75 0.4375C8.75 0.195875 8.94588 0 9.1875 0H12.6875C13.4124 0 14 0.587626 14 1.3125V4.8125C14 5.05412 13.8041 5.25 13.5625 5.25C13.3209 5.25 13.125 5.05412 13.125 4.8125V1.3125C13.125 1.07088 12.9291 0.875 12.6875 0.875H9.1875C8.94588 0.875 8.75 0.679125 8.75 0.4375ZM0.4375 8.75C0.679125 8.75 0.875 8.94588 0.875 9.1875V12.6875C0.875 12.9291 1.07088 13.125 1.3125 13.125H4.8125C5.05412 13.125 5.25 13.3209 5.25 13.5625C5.25 13.8041 5.05412 14 4.8125 14H1.3125C0.587626 14 0 13.4124 0 12.6875V9.1875C0 8.94588 0.195875 8.75 0.4375 8.75ZM13.5625 8.75C13.8041 8.75 14 8.94588 14 9.1875V12.6875C14 13.4124 13.4124 14 12.6875 14H9.1875C8.94588 14 8.75 13.8041 8.75 13.5625C8.75 13.3209 8.94588 13.125 9.1875 13.125H12.6875C12.9291 13.125 13.125 12.9291 13.125 12.6875V9.1875C13.125 8.94588 13.3209 8.75 13.5625 8.75Z"
				fill="currentColor"
			/>
			<path
				clipRule="evenodd"
				d="M6.6993 2.90737C6.86526 2.74149 7.13491 2.74149 7.30086 2.90737L8.61662 4.22313V3.79149C8.61669 3.55683 8.80707 3.36636 9.04175 3.36636H9.62508C9.85976 3.36636 10.0501 3.55683 10.0502 3.79149V5.65672L10.8009 6.40737C10.8805 6.48705 10.9252 6.59548 10.9252 6.70815V10.7915C10.9252 11.0262 10.7348 11.2166 10.5001 11.2166H7.87508C7.64036 11.2166 7.44995 11.0262 7.44995 10.7915V8.59162H6.55021V10.7915C6.55021 11.0262 6.3598 11.2166 6.12508 11.2166H3.50008C3.26536 11.2166 3.07495 11.0262 3.07495 10.7915V6.70815C3.07499 6.59548 3.11963 6.48705 3.1993 6.40737L6.6993 2.90737ZM3.92521 6.88394V10.3664H5.69995V8.16649C5.70002 7.93183 5.8904 7.74136 6.12508 7.74136H7.87508C8.10976 7.74136 8.30014 7.93183 8.30021 8.16649V10.3664H10.075V6.88394L7.00008 3.80907L3.92521 6.88394Z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	);
};

export default HomeBracketsIcon;
